import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VShowSlide from 'v-show-slide'
import VueMq from 'vue-mq'
import { EventBus } from '@/event-bus.js'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(VShowSlide)
Vue.use(VueMq, {
	breakpoints: {
		xs     : 500,
		sm     : 715,
		md     : 1130,
		desktop: 1364,
		lg     : 1365,
		xl     : 1950,
	}
})

// Setup and mount root
new Vue({
	router,
	store,
	data() {
		return {}
	},
	watch: {},
	computed: {},
	methods: {},
	created(){},
	mounted(){},
	render: h => h(App)
}).$mount('#app')
